"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect, useMemo, useRef, useState, type MouseEvent } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useKey } from "react-use";
import BellIcon from "@/components/common/icons/BellIcon";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import HeaderSearchModal from "@/components/header/header-search/HeaderSearchModal";
import { useUnreadNotifications } from "@/hooks/useUnreadNotifications";
import { useIdentity } from "../../../hooks/useIdentity";
import { useAuth } from "../../auth/Auth";
import { useSeizeConnectContext } from "../../auth/SeizeConnectContext";
import HeaderShare from "../../header/share/HeaderShare";
import WebSidebarHeader from "./WebSidebarHeader";
import WebSidebarNav from "./WebSidebarNav";
import WebSidebarNavItem from "./nav/WebSidebarNavItem";
import WebSidebarUser from "./WebSidebarUser";
import { MagnifyingGlassIcon, UserIcon } from "@heroicons/react/24/outline";
interface WebSidebarProps {
  readonly isCollapsed: boolean;
  readonly onToggle: () => void;
  readonly isMobile: boolean;
  readonly isNarrow?: boolean | undefined;
  readonly isOffcanvasOpen: boolean;
  readonly onCloseOffcanvas: () => void;
  readonly sidebarWidth: string;
}
function WebSidebar(t0) {
  const $ = _c(82);
  const {
    isCollapsed,
    onToggle,
    isMobile,
    isNarrow: t1,
    isOffcanvasOpen,
    onCloseOffcanvas,
    sidebarWidth
  } = t0;
  const isNarrow = t1 === undefined ? false : t1;
  const navRef = useRef(null);
  const pathname = usePathname();
  const {
    address
  } = useSeizeConnectContext();
  const {
    connectedProfile
  } = useAuth();
  const t2 = address || "";
  let t3;
  if ($[0] !== t2) {
    t3 = {
      handleOrWallet: t2,
      initialProfile: null
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    profile
  } = useIdentity(t3);
  const {
    haveUnreadNotifications
  } = useUnreadNotifications(connectedProfile?.handle ?? null);
  connectedProfile?.handle;
  let t4;
  bb0: {
    if (connectedProfile?.handle) {
      t4 = `/${connectedProfile.handle}`;
      break bb0;
    }
    if (address) {
      t4 = `/${address}`;
      break bb0;
    }
    t4 = null;
  }
  const profilePath = t4;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const showDesktopSearch = !isMobile;
  let t5;
  if ($[2] !== showDesktopSearch) {
    t5 = event_0 => {
      if (!(event_0.metaKey || event_0.ctrlKey)) {
        return;
      }
      event_0.preventDefault();
      if (showDesktopSearch) {
        setIsSearchOpen(true);
      }
    };
    $[2] = showDesktopSearch;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      event: "keydown"
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  useKey(_temp, t5, t6);
  let t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      const {
        window: browserWindow
      } = globalThis as typeof globalThis & {
        window?: Window | undefined;
      };
      if (browserWindow === undefined || typeof browserWindow.matchMedia !== "function") {
        setIsTouchScreen(false);
        return;
      }
      const coarsePointerQuery = browserWindow.matchMedia("(pointer: coarse)");
      const handlePointerChange = event_1 => {
        setIsTouchScreen(event_1.matches);
      };
      setIsTouchScreen(coarsePointerQuery.matches);
      if (typeof coarsePointerQuery.addEventListener === "function") {
        coarsePointerQuery.addEventListener("change", handlePointerChange);
        return () => coarsePointerQuery.removeEventListener("change", handlePointerChange);
      }
      if ("onchange" in coarsePointerQuery) {
        const originalHandler = coarsePointerQuery.onchange;
        coarsePointerQuery.onchange = handlePointerChange;
        return () => {
          if (coarsePointerQuery.onchange === handlePointerChange) {
            coarsePointerQuery.onchange = originalHandler ?? null;
          }
        };
      }
    };
    t8 = [];
    $[5] = t7;
    $[6] = t8;
  } else {
    t7 = $[5];
    t8 = $[6];
  }
  useEffect(t7, t8);
  const prevPathnameRef = useRef(pathname);
  const isOverlayActive = isOffcanvasOpen && (isMobile || isNarrow);
  let t10;
  let t9;
  if ($[7] !== isMobile || $[8] !== isOffcanvasOpen || $[9] !== isOverlayActive || $[10] !== onCloseOffcanvas || $[11] !== pathname) {
    t9 = () => {
      if (prevPathnameRef.current !== pathname) {
        prevPathnameRef.current = pathname;
        if ((isMobile || isOverlayActive) && isOffcanvasOpen) {
          onCloseOffcanvas();
        }
      }
    };
    t10 = [pathname, isMobile, isOverlayActive, isOffcanvasOpen, onCloseOffcanvas];
    $[7] = isMobile;
    $[8] = isOffcanvasOpen;
    $[9] = isOverlayActive;
    $[10] = onCloseOffcanvas;
    $[11] = pathname;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[14] !== isMobile || $[15] !== isOffcanvasOpen || $[16] !== isOverlayActive || $[17] !== onCloseOffcanvas) {
    t11 = () => {
      if (!isMobile && !isOverlayActive || !isOffcanvasOpen) {
        return;
      }
      const {
        window: browserWindow_0
      } = globalThis as typeof globalThis & {
        window?: Window | undefined;
      };
      if (browserWindow_0 === undefined) {
        return;
      }
      const handleEscapeKey = e => {
        if (e.key === "Escape") {
          onCloseOffcanvas();
        }
      };
      browserWindow_0.addEventListener("keydown", handleEscapeKey);
      return () => browserWindow_0.removeEventListener("keydown", handleEscapeKey);
    };
    t12 = [isMobile, isOffcanvasOpen, isOverlayActive, onCloseOffcanvas];
    $[14] = isMobile;
    $[15] = isOffcanvasOpen;
    $[16] = isOverlayActive;
    $[17] = onCloseOffcanvas;
    $[18] = t11;
    $[19] = t12;
  } else {
    t11 = $[18];
    t12 = $[19];
  }
  useEffect(t11, t12);
  const shouldShowCollapsed = isMobile && isOffcanvasOpen ? false : isCollapsed;
  const scrollContainerRef = useRef(null);
  let t13;
  if ($[20] !== onToggle) {
    t13 = () => {
      navRef.current?.closeSubmenu();
      onToggle();
    };
    $[20] = onToggle;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const handleToggle = t13;
  const shouldRenderSidebar = !isMobile || isOffcanvasOpen;
  if (!shouldRenderSidebar) {
    return null;
  }
  let t14;
  if ($[22] !== isMobile || $[23] !== isOverlayActive || $[24] !== onCloseOffcanvas) {
    t14 = isOverlayActive && <button type="button" className={isMobile ? "tw-fixed tw-inset-0 tw-z-[70] tw-border-0 tw-bg-gray-600 tw-bg-opacity-50 focus:tw-outline-none" : "tw-fixed tw-inset-0 tw-z-30 tw-border-0 tw-bg-gray-600 tw-bg-opacity-50 focus:tw-outline-none"} onClick={onCloseOffcanvas} aria-label="Close menu overlay" />;
    $[22] = isMobile;
    $[23] = isOverlayActive;
    $[24] = onCloseOffcanvas;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = isMobile ? "tw-fixed tw-inset-y-0 tw-left-0 tw-z-[80] focus:tw-outline-none" : "tw-fixed tw-inset-y-0 tw-left-0 tw-z-40 focus:tw-outline-none";
  let t16;
  if ($[26] !== isMobile) {
    t16 = isMobile ? undefined : {
      left: "var(--layout-margin, 0px)"
    };
    $[26] = isMobile;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== sidebarWidth) {
    t17 = {
      width: sidebarWidth
    };
    $[28] = sidebarWidth;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== handleToggle || $[31] !== shouldShowCollapsed) {
    t18 = <WebSidebarHeader collapsed={shouldShowCollapsed} onToggle={handleToggle} />;
    $[30] = handleToggle;
    $[31] = shouldShowCollapsed;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== shouldShowCollapsed) {
    t19 = <div className="tw-flex-1"><WebSidebarNav ref={navRef} isCollapsed={shouldShowCollapsed} /></div>;
    $[33] = shouldShowCollapsed;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== shouldShowCollapsed || $[36] !== showDesktopSearch) {
    t20 = showDesktopSearch && <div className="tw-px-3 tw-pt-2"><WebSidebarNavItem onClick={event_2 => {
        event_2?.stopPropagation();
        setIsSearchOpen(true);
      }} icon={MagnifyingGlassIcon} active={false} collapsed={shouldShowCollapsed} label="Search" /></div>;
    $[35] = shouldShowCollapsed;
    $[36] = showDesktopSearch;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== address || $[39] !== haveUnreadNotifications || $[40] !== pathname || $[41] !== shouldShowCollapsed || $[42] !== showDesktopSearch) {
    t21 = address && <div className={showDesktopSearch ? "tw-px-3" : "tw-px-3 tw-pt-2"}><WebSidebarNavItem href="/notifications" icon={BellIcon} active={pathname?.startsWith("/notifications") || false} collapsed={shouldShowCollapsed} label="Notifications" hasIndicator={haveUnreadNotifications} /></div>;
    $[38] = address;
    $[39] = haveUnreadNotifications;
    $[40] = pathname;
    $[41] = shouldShowCollapsed;
    $[42] = showDesktopSearch;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== pathname || $[45] !== profilePath || $[46] !== shouldShowCollapsed) {
    t22 = profilePath && <div className="tw-px-3"><WebSidebarNavItem href={profilePath} icon={UserIcon} iconSizeClass="tw-h-6 tw-w-6" active={pathname === profilePath} collapsed={shouldShowCollapsed} label="Profile" /></div>;
    $[44] = pathname;
    $[45] = profilePath;
    $[46] = shouldShowCollapsed;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== address || $[49] !== shouldShowCollapsed) {
    t23 = !address && <HeaderShare isCollapsed={shouldShowCollapsed} />;
    $[48] = address;
    $[49] = shouldShowCollapsed;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== profile || $[52] !== shouldShowCollapsed) {
    t24 = <WebSidebarUser isCollapsed={shouldShowCollapsed} profile={profile} />;
    $[51] = profile;
    $[52] = shouldShowCollapsed;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t19 || $[55] !== t20 || $[56] !== t21 || $[57] !== t22 || $[58] !== t23 || $[59] !== t24) {
    t25 = <div className="no-scrollbar tw-flex tw-h-full tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300" data-sidebar-scroll="true">{t19}{t20}{t21}{t22}{t23}{t24}</div>;
    $[54] = t19;
    $[55] = t20;
    $[56] = t21;
    $[57] = t22;
    $[58] = t23;
    $[59] = t24;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t18 || $[62] !== t25) {
    t26 = <div className="tw-flex tw-h-full tw-flex-col tw-pt-2">{t18}{t25}</div>;
    $[61] = t18;
    $[62] = t25;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== t17 || $[65] !== t26) {
    t27 = <div className="tw-group tw-relative tw-z-50 tw-h-full tw-border-0 tw-border-y-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-iron-800 tw-bg-black tw-transition-[width] tw-duration-300 tw-ease-in-out focus:tw-outline-none" style={t17} aria-label="Primary sidebar" ref={scrollContainerRef}>{t26}</div>;
    $[64] = t17;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t15 || $[68] !== t16 || $[69] !== t27) {
    t28 = <div className={t15} style={t16}>{t27}</div>;
    $[67] = t15;
    $[68] = t16;
    $[69] = t27;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  let t29;
  if ($[71] !== isSearchOpen) {
    t29 = isSearchOpen && <CommonAnimationOpacity key="search-modal" elementClasses="tw-fixed tw-inset-0 tw-z-50" elementRole="dialog" onClicked={_temp2}><HeaderSearchModal onClose={() => setIsSearchOpen(false)} wave={null} /></CommonAnimationOpacity>;
    $[71] = isSearchOpen;
    $[72] = t29;
  } else {
    t29 = $[72];
  }
  let t30;
  if ($[73] !== t29) {
    t30 = <CommonAnimationWrapper mode="sync" initial={true}>{t29}</CommonAnimationWrapper>;
    $[73] = t29;
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== isTouchScreen) {
    t31 = !isTouchScreen && <ReactTooltip id="sidebar-tooltip" place="right" offset={16} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 9999,
      pointerEvents: "none"
    }} border="1px solid #4C4C55" />;
    $[75] = isTouchScreen;
    $[76] = t31;
  } else {
    t31 = $[76];
  }
  let t32;
  if ($[77] !== t14 || $[78] !== t28 || $[79] !== t30 || $[80] !== t31) {
    t32 = <>{t14}{t28}{t30}{t31}</>;
    $[77] = t14;
    $[78] = t28;
    $[79] = t30;
    $[80] = t31;
    $[81] = t32;
  } else {
    t32 = $[81];
  }
  return t32;
}
function _temp2(event_3) {
  return event_3.stopPropagation();
}
function _temp(event) {
  return event.key === "k";
}
export default WebSidebar;